export class BrowserInfo {
    userAgent;
    name;
    version;
    mobile;
    constructor(userAgent, name, version, mobile = false) {
        this.userAgent = userAgent;
        this.name = name;
        this.version = version;
        this.mobile = mobile;
    }
    wasDetermined() {
        return this.name !== null && this.version !== null;
    }
    description(separator = ' ') {
        if (this.name === null) {
            return 'Unknown';
        }
        let description = '';
        switch (this.name) {
            case "chrome":
                description = 'Chrome ' + this.version;
                break;
            case "chromeIos":
                description = 'Chrome (iOS) ' + this.version;
                break;
            case "firefox":
                description = 'Firefox ' + this.version;
                break;
            case "firefoxIos":
                description = 'Firefox (iOS) ' + this.version;
                break;
            case "edge":
                description = 'Edge ' + this.version;
                break;
            case "ie":
                description = 'Internet Explorer ' + this.version;
                break;
            case "opera":
                description = 'Opera ' + this.version;
                break;
            case "safari":
                description = 'Safari ' + this.version;
                break;
        }
        if (this.mobile) {
            description += ' [Mobile]';
        }
        return description.split(' ').join(separator);
    }
    supportsWebrtcTask() {
        switch (this.name) {
            case "safari":
                return !this.mobile;
            case "firefoxIos":
            case "chromeIos":
                return false;
            default:
                return true;
        }
    }
    isFirefox(requireVersion = false) {
        return this.name === "firefox" && (!requireVersion || this.version !== null);
    }
    isSafari(requireVersion = false) {
        return this.name === "safari" && (!requireVersion || this.version !== null);
    }
}
